/**
 * A Channel is a bi-directional messaging data structure in which one channel
 * can send and receive messages to and from the other.
 *
 * @usage
 * const A = new Channel()
 * const B = new Channel()
 *
 * A.bind(B)
 * B.bind(A)
 *
 * A.listen((x) => console.log(x * 2))
 * B.listen(console.log)
 *
 * B.send(5)      // => The A listener prints 10
 * A.send('foo')  // => The B listener prints 'foo'
 */
var Channel = /** @class */ (function () {
    function Channel(channel) {
        var _this = this;
        this.listeners = new Set();
        this.bind = function (channel) {
            _this.dest = channel;
        };
        this.unbind = function () {
            _this.dest = undefined;
        };
        this.send = function (message) {
            var _a;
            (_a = _this.dest) === null || _a === void 0 ? void 0 : _a.receive(message);
        };
        this.listen = function (handler) {
            _this.listeners.add(handler);
        };
        this.dest = channel;
    }
    Channel.prototype.receive = function (message) {
        if (this.listeners.size) {
            this.listeners.forEach(function (f) { return f(message); });
        }
    };
    return Channel;
}());
export default Channel;
//# sourceMappingURL=Channel.js.map